export const theme = {
    namespaced: true,

    state: {
        bgIndex: 0
    },

    mutations: {
        SET_THEME(state, index) {
            state.bgIndex = index
        }
    }
}
